import api from './api';

export const projectTimelineService = {
  // Add a timeline event/appointment to project
  addTimelineEvent: async (projectId, eventData) => {
    try {
      const response = await api.post(`/projects/${projectId}/timeline-events`, eventData);
      return response.data;
    } catch (error) {
      console.error('Error adding timeline event:', error);
      throw error;
    }
  },

  // Update a timeline event
  updateTimelineEvent: async (projectId, eventIndex, eventData) => {
    try {
      const response = await api.put(`/projects/${projectId}/timeline-events/${eventIndex}`, eventData);
      return response.data;
    } catch (error) {
      console.error('Error updating timeline event:', error);
      throw error;
    }
  },

  // Delete a timeline event
  deleteTimelineEvent: async (projectId, eventIndex) => {
    try {
      const response = await api.delete(`/projects/${projectId}/timeline-events/${eventIndex}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting timeline event:', error);
      throw error;
    }
  }
};
